import { appUrl, form } from '../../utils/variables';
import { t } from '../../utils/i18n';

export function loadProviderList(providers) {
    let list = document.querySelector('.providers__container .providers__list');
    list.innerHTML = '';

    if (providers.length <= 0) {
        list.insertAdjacentHTML(
            'beforeend',
            `
        <div class="noProcedures">${t('no_providers_found')}</div>
        `
        );
    }

    if (providers.length > 0) {
        list.insertAdjacentHTML(
            'beforeend',
            `
        <div class="providers__list--title">${t('select_provider')}</div>
        `
        );
    }

    if (providers.length > 1 && form?.appointment_channel?.show_any_provider_option) {
        list.insertAdjacentHTML(
            'beforeend',
            `
            <div class="provider no-preference-provider" data-provider-id="-1" data-provider="no-preference">
                <i class="ri-group-line"></i>
                <div>
                    <span class="provider__name">${t('any_provider')}</span>
                    <div style="margin-right: 10px;" class="provider__title">${t('soonest_available')}</div>
                </div>
                <span class="provider__option" data-provider-id="-1">
                    <i class="provider__icon-check ri-check-line"></i>
                </span>
            </div>
            `
        );
    }

    if (providers.length > 0) {
        for (const i of providers) {
            const name = i.first_name + ' ' + i.last_name;

            list.insertAdjacentHTML(
                'beforeend',
                `
            <div class="provider" data-provider-id="${i.id}" data-provider="${name}">
                <img src="${i?.photo ? i.photo : `${appUrl}/assets/images/png/default-avatar.png`}"/>
                <div class="provider__info-wrapper">
                    <span class="provider__name">${name}</span>
                    ${i.title ? `<div style="margin-right: 10px;" class="provider__title">${i.title}</div>` : ''}
                </div>
                <span class="provider__option" data-provider-id="${i.id}">
                    <i class="provider__icon-check ri-check-line"></i>
                </span>
            </div>
            `
            );
        }
    }
}

export function loadProviderBaseOnLocation(unSelectedProviders) {
    const providerArray = document.querySelectorAll('.providers__container .provider');
    for (let i = 0; i < unSelectedProviders.length; i++) {
        providerArray.forEach(element => {
            if (element.getAttribute("data-provider-id") == unSelectedProviders[i]?.id) {
                element.classList.add('hidden');
            }
        });
    }
}
